import React from "react"

const Footer = () => {
  return (
    <div
      style={{
        color: "var(--primary)",
        position: "absolute",
        bottom: "0",
        left: "50%",
        marginLeft: "-94.625px",
      }}
    >
      Copyright &copy; Better Buy
    </div>
  )
}

export default Footer
